import labels from './i18n/globalToggle.js';

function globalToggle(widget, options) {
  options = $.extend(
    {
      before: true,
      after: true
    },
    options
  );

  let actionIsOpen = true;
  const buttons = [];

  /**
   * init - Init the widget by creating the required button(s)
   *
   * @return {undefined}
   */
  function init() {
    for (const position in options) {
      if (options[position]) {
        create(position);
      }
    }
  }

  /**
   * create - Handle the button creation
   *
   * @param  {string} where The position to insert the button
   * @return {undefined}
   */
  function create(where) {
    const button = createButton('all', labels.open);
    $(widget.element)[where](button);
    $(widget.element).attr('id', `${widget.guid}-global-toggle`);
    buttons.push(button);
  }

  /**
   * createButton - Create the markup of the button
   *
   * @param  {integer} index The index of the button
   * @param  {string} text The button text content
   * @return {object} Skizz object of the button
   */
  function createButton(index, text) {
    return $('<button></button>')
      .addClass(`${widget.id}-global-toggle`)
      .attr('data-index', index)
      .attr('aria-controls', `${widget.guid}-global-toggle`)
      .text(text)
      .on('click', eventHandler);
  }

  /**
   * eventHandler - Handle button's logic
   *
   * @param  {object} event The event object
   * @return {undefined}
   */
  function eventHandler(event) {
    event.preventDefault();
    widget.items.each(function (index) {
      if (actionIsOpen) {
        widget.open(index);
      } else {
        widget.close(index);
        event.target.focus();
      }
    });

    updateButtons();
    updateAction();
  }

  /**
   * updateAction - Update the type of action to perform (open or close)
   *
   * @return {undefined}
   */
  function updateAction() {
    actionIsOpen = !actionIsOpen;
  }

  /**
   * updateButtons - Update text in all buttons
   *
   * @return {undefined}
   */
  function updateButtons() {
    buttons.forEach(function (button) {
      button.text(!actionIsOpen ? labels.open : labels.close);
    });
  }

  /**
   * destroy - Clear event listeners and remove all created elements
   *
   * @return {undefined}
   */
  function destroy() {
    buttons.forEach(function (button) {
      button.off('click', eventHandler);
      button.detach();
    });
  }

  init();

  return {
    destroy
  };
}

globalToggle.id = 'globalToggle';

export default globalToggle;
